export default __webpack_public_path__ + "static/media/0.72059a7f.jpg";